@if (showToggleAllocation) {
<div>
  <button type="button" class="btn btn-primary btn-lg"
    (click)="toggleAllocationModule()">Allocate to this module</button>
</div>
} @else {
<div>
  <div class="asset-header">
    <span class="header-lable-sm">Assets: </span><span>{{ totalMappedAssets }}</span>
    <span class="header-lable-sm">Total Allocation: </span><span>{{ totalAllocationPercentage | percent:'2.2-4' }}</span>
  </div>
  <mat-drawer-container class="multi-asset-container">
    <mat-drawer #drawer mode="side">
      <div class="asset-available-selection">
        <div position="top" class="p-1 k-header k-grid-toolbar">
          <button type="button" kendoButton (click)="drawer.toggle(); addAssetToMapping();"
            [disabled]="disableAddSelected" class="k-button k-primary">
            Add Selected
          </button>
          <button type="button" kendoButton (click)="drawer.toggle(); cancelAvailableAssetsSelection()"
            class="k-button k-primary">
            Cancel
          </button>
        </div>
        <ag-grid-angular #availablesGrid class="ag-theme-balham content-grid"
          (gridReady)="onAvailablesGridReady($event)"
          [gridOptions]="availablesGridOptions"
          (selectionChanged)="onAvailablesSelectionChanged($event)">
        </ag-grid-angular>
      </div>
    </mat-drawer>
    <mat-drawer-content #content>
      <div class="asset-sidenav-content">
        <div position="top" class="p-1 k-header k-grid-toolbar">
          <button type="button" kendoButton themeColor="primary" [disabled]="!moduleIsEditable"
            (click)="drawer.toggle(); " class="k-button k-primary">
            Add
          </button>
          @if (allocationAllowed) {
          <button type="button" kendoButton themeColor="primary" [disabled]="!moduleIsEditable || disableAllocateEvenly" class='k-button k-primary'
            (click)='splitAllocation();'>
            Allocate Evenly
          </button>
          }
          <button type="button" kendoButton themeColor="primary" (click)="removeMappedAssets()"
            class="k-button k-primary" [disabled]="disableRemoveMapped">
            Remove
          </button>
        </div>
        <ag-grid-angular #mappedGrid class="ag-theme-balham content-grid" (gridReady)="onMappedGridReady($event)"
          [gridOptions]="mappedGridOptions"
          (selectionChanged)="onMappedSelectionChanged($event)"
          (cellValueChanged)="onMappedCellValueChanged($event)">
        </ag-grid-angular>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
}